import React from 'react';
import { twMerge } from 'tailwind-merge';

import './FolderSelectorLoadingIndicator.css';

interface Props {
    compact?: boolean;
    show?: boolean;
}

const FolderSelectorLoadingIndicator: React.FC<Props> = ({ compact = false, show = true }) => {
    if (!show) {
        return null;
    }

    const cssClasses = twMerge('la-loading-indicator la-ball-newton-cradle la-2x la-delayed', compact && 'la-compact');

    return (
        <div className={cssClasses}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default FolderSelectorLoadingIndicator;
